import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from '@patternfly/react-core';
import { useContext } from 'react';
import { useFieldValue } from '../hooks/field-value';
import { SchemaContext } from '../providers/SchemaProvider';
import { FieldWrapper } from './FieldWrapper';
export const BooleanField = ({ propName, required }) => {
    var _a;
    const { schema } = useContext(SchemaContext);
    const { value, onChange, disabled } = useFieldValue(propName);
    const onFieldChange = (_event, checked) => {
        onChange(checked);
    };
    const id = `${propName}-popover`;
    return (_jsx(FieldWrapper, { propName: propName, required: required, title: schema.title, type: "boolean", description: schema.description, defaultValue: (_a = schema.default) === null || _a === void 0 ? void 0 : _a.toString(), isRow: true, children: _jsx(Switch, { id: propName, name: propName, role: "checkbox", "aria-label": schema.title, "aria-describedby": id, isChecked: value, checked: value, onChange: onFieldChange, isDisabled: disabled }) }));
};
//# sourceMappingURL=BooleanField.js.map